import React         from "react";

class FormatPrice extends React.Component {


	render() {
		let price = 0;
		let sprice = 0;
		let NYR = "";
		if(this.props.lot.display_sprice === 1) {
			sprice = parseInt(this.props.lot.sprice, 10);
			price = parseInt(this.props.lot.price, 10);
		}
		else if(this.props.lot.price === "0"){
			NYR = "Not yet released";
		}
		else {
			price = parseInt(this.props.lot.price, 10);
		}
		//apply regex to format the int into a readable currency
		let formattedPrice ="$" + price.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,');
		let formattedSPrice ="$" + sprice.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,');

		if(this.props.lot.display_sprice === 1) {
			return (
				<div>
					<div className="hotlot-splash-row">ON SALE!</div><br />
					<div className="sprice">{formattedSPrice}</div>
				</div>
			);
		} else if (this.props.lot.price === "0"){
			return (
				<div>
					<div>{NYR}</div><br/>
					<div></div>
				</div>
			)
		} else {
			return (
				<div>
					<div>{formattedPrice}</div><br/>
					<div></div>
				</div>
			)
		}
	}
}

// export the newly generated component
export default FormatPrice;


/** WEBPACK FOOTER **
 ** ./src/modules/common/FormatPrice.js
 **/